import { storyblokEditable } from "gatsby-source-storyblok"

import ContentHalfHero from "../../../../V2/Heroes/Content/HalfHero"

import { storyblokLinkToYocoLink } from "@utils/storyblok"
import React from "react"

const StoryblokContentHalfHero = ({
  blok,
}: Storyblok.BlokProps<Storyblok.ContentHalfHero>) => {
  const calloutItems = blok.callout?.map((item) => ({
    text: item.text,
    highlightedWord: item.highlightedWord,
    highlightColor: item.highlightColor,
    hasBorder: item.hasBorder,
    hasIcon: item.hasIcon,
    iconAlt: item.icon?.alt || "",
    iconUrl: item.icon?.filename || "",
    iconColor: item.iconColor,
    ctaText: item.ctaText,
    ctaLink: storyblokLinkToYocoLink(item.ctaLink),
  }))

  return (
    <ContentHalfHero
      primaryBackgroundColor={blok.backgroundColor}
      secondaryBackgroundColor={blok.secondaryBackgroundColor}
      priceBadge={blok.priceBadge?.[0]}
      primaryButtonBorderColor={blok.primaryCTAColor}
      bodyText={blok.bodyText}
      headingText={blok.headingText}
      headingImage={blok.headingImage?.filename}
      mobileImage={blok.mobileImage?.filename}
      headingSize={blok.headingSize}
      headingFontFamily={blok.headingFontFamily}
      headingMobileAlignment={blok.headingMobileAlignment}
      superscriptText={blok.superscriptText}
      imageAlt={blok.image.alt}
      imageUrl={blok.image.filename}
      primaryButtonLink={storyblokLinkToYocoLink(blok.primaryCTALink)}
      primaryButtonMobileLink={
        storyblokLinkToYocoLink(blok.primaryCTAMobileLink) ?? ""
      }
      primaryButtonText={blok.primaryCTAText}
      primaryButtonMobileText={blok.primaryCTAMobileText}
      trackingEvent={blok.trackingEvent}
      trackingEventKey={blok.trackingEventKey}
      trackingEventValue={blok.trackingEventValue}
      secondaryButtonLink={storyblokLinkToYocoLink(blok.secondaryCTALink) ?? ""}
      secondaryButtonMobileText={blok.secondaryCTAMobileText}
      secondaryButtonMobileLink={
        storyblokLinkToYocoLink(blok.secondaryCTAMobileLink) ?? ""
      }
      secondaryButtonText={blok.secondaryCTAText}
      videoUrl={
        blok.video
          ? blok.video.filename
          : (storyblokLinkToYocoLink(blok.videoUrl)?.url ?? "")
      }
      secondaryCTATextColor={blok.secondaryCTATextColor}
      callout={calloutItems?.[0]}
      showDownloadAppButton={blok.showDownloadAppButton}
      hasScrollArrow={blok.hasScrollArrow}
      hideMobileStickyButton={blok.hideMobileStickyButton}
      digitalPaymentsText={blok.digitalPaymentsText}
      secondaryTrackingEvent={blok.secondaryTrackingEvent}
      secondaryTrackingEventKey={blok.secondaryTrackingEventKey}
      secondaryTrackingEventValue={blok.secondaryTrackingEventValue}
      // @ts-ignore
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokContentHalfHero
